import { render, staticRenderFns } from "./RealNameAuthentication.vue?vue&type=template&id=a8842e20&scoped=true&"
import script from "./RealNameAuthentication.vue?vue&type=script&lang=js&"
export * from "./RealNameAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./RealNameAuthentication.vue?vue&type=style&index=0&id=a8842e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8842e20",
  null
  
)

export default component.exports